module.exports = __webpack_public_path__ + "img/logo.23ea3c3c.png";